/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Orders_ReturnedInputs */

const vi_report_orders_returned = /** @type {(inputs: Report_Orders_ReturnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn trả`)
};

/**

* @param {Report_Orders_ReturnedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_orders_returned = /** @type {((inputs?: Report_Orders_ReturnedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Orders_ReturnedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_orders_returned(inputs)
});